/** Minutes as "7 h 39 m", "45 m" or "8 h" (rounded to the minute; negative values keep their sign). */
export function formatDurationMinutes(minutes: number): string {
  if (!Number.isFinite(minutes)) return '—';
  const total = Math.round(minutes);
  if (total < 0) return `−${formatDurationMinutes(-total)}`;
  const hours = Math.floor(total / 60);
  const rest = total % 60;
  return hours ? (rest ? `${hours} h ${rest} m` : `${hours} h`) : `${rest} m`;
}
